//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
import activateTypeFilter from '~/mixins/ResourceFilterFunctions/type.js';
import deactivateFilter from '~/mixins/ResourceFilterFunctions/deactivate-filter.js';
export default {
  mixins: [activateTypeFilter, deactivateFilter],
  computed: {
    ...mapState({
      filterDropdown: ({ dropdownStore: { filterDropdown } }) => filterDropdown,
      filter: ({ filtersStore: { filter } }) => filter,
      queries: ({ resourcesStore: { queries } }) => queries,
    }),
  },
};
